module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture4-a3deadeabef982b62abe2a0567f371e6.jpg";